import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'

export default class CheckBoxList extends React.Component {
  constructor (props) {
    super()
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage()
    }
  }

  renderLable (item) {
    if (window.location.pathname.indexOf('/leaderboardGroup') !== -1) {
      return item.Store_Name ? item.Store_Name + '-' + item.Store_Number : item.Store_Number
    } else {
      return item.Type === 'group' ? item.GroupName : item.GroupName ? item.Store_Number + '-' + item.GroupName + ' (' + item.CompanyName + ')' : item.Store_Number + ' (' + item.CompanyName + ')'
    }
  }
  render () {
    const language = this.state.currentLanguage
    console.log(this.props.items)
    return (
      <div className='col-xs-12 col-sm-12 col-md-5 col-lg-4'>
        {this.props.title}:
        <div className='select-all-groups alignCenter'>
          <input type='checkbox' onChange={(event) => this.props.selectAll(event, this.props.items)} name='selectAll' id={this.props.type} />
          <span className='textPaddingSmall'>&nbsp;{t[language].selectall}</span>
        </div>
        <div className='col-xs-12 new-groups'>
          <ul className='unlinked-grouplist'>
            {
              this.props.items.map(item =>
                <li className='' key={item.Id}>
                  <label><input type='checkbox' name='availableItem' checked={item.selected} onChange={(e) => this.props.toggle(item)} />
                  </label>
                  <span className='checkboxPool'>{this.renderLable(item)}</span>
                </li>)
            }
          </ul>
        </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/Group/CheckBoxList.js